import React, { useState, useEffect } from "react";
import { PieChart } from "react-minimal-pie-chart";
import MaterialTable from "./components/MaterialTable";
import MaterialTableValues from "./components/MaterialTableValues";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useRecoilState, useRecoilValue } from "recoil";
import config from "../../../../../config";
import {
  CCPolyCo2TotalTodaySData,
  CCPolyCo2TotalTomorrowSData,
  CCPolyVolumeReductionData,
  CCPolyEnergyMaterialData,
  CCPolyEnergySystemData,
  CCPolyCo2ePowderScenarioData,
  CCPolyCo2eEnergyData,
  CCPolyPowderData,
  CCPolyVolumeReductionState,
  CCPolyCarbonNeutralPowder,
  CCPolyEnergyPercentage,
  CCPolyGreenPowderEnergy,
  CCPolyModeOfTranspotation1,
  CCPolyModeOfTranspotation2,
  CCRefreshRateScenarioState
} from "atoms/CCPolymer/CCPolyScenario";
import { CCPolyCo2ePerPartPMData } from "atoms/CCPolymer/CCPolyPowderMFG";
import { CCPolyCo2ePerPartMPData } from "atoms/CCPolymer/CCPolyMaterialProcessing";
import { CCPolyCo2ePerPartAPData } from "atoms/CCPolymer/CCPolyAmProcess";

import { useGetMachineName } from "app/view/hooks/useGetMachineName";
import { useGetMaterialName } from "app/view/hooks/useGetMaterialById";
import {
  CCPolyCo2ePerPartTPData,
  CCPolyMaterialTransportationData,
  CCPolySystemTransportationData,
  CCPolyCarbonEmissionFactorNode1Data,
  CCPolyCarbonEmissionFactorNode2Data,
} from "atoms/CCPolymer/CCPolyTransportation";
import { DebounceInput } from "react-debounce-input";
import {
  technologyId,
  stepTypeId,
  technologyType,
  HighestIndexArray
} from "atoms/General/index.js";
import MaterialTableValues1 from "./components/MaterialTableValues1";

const axios = require("axios").default;
const Scenario = ({ ScenarioState, socket }) => {
  const shiftSize = 7;
  const co2TotalToday = useRecoilValue(CCPolyCo2TotalTodaySData);
  const co2TotalTomorrow = useRecoilValue(CCPolyCo2TotalTomorrowSData);
  const cPowder = useRecoilValue(CCPolyPowderData);
  const volumeReduction = useRecoilValue(CCPolyVolumeReductionData);
  const energyMaterial = useRecoilValue(CCPolyEnergyMaterialData);
  const Powder = useRecoilValue(CCPolyCo2ePowderScenarioData);
  const Energy = useRecoilValue(CCPolyCo2eEnergyData);
  const EnergySystem = useRecoilValue(CCPolyEnergySystemData);
  const [powder, setPowder] = useState();
  const [co2ePowder, setCo2ePowder] = useState();
  const [co2eEnergy, setCo2eEnergy] = useState();
  const [EnergyMaterial, setEnergyMaterial] = useState();
  const [energySystem, setEnergySystem] = useState();
  const [VolumeReduction, setVolumeReduction] = useState();
  const co2TotalTransportation = useRecoilValue(CCPolyCo2ePerPartTPData);
  const techId = useRecoilValue(technologyId);
  const stepId = useRecoilValue(stepTypeId);
  const techName = useRecoilValue(technologyType);
  const costData = JSON.parse(localStorage.getItem("CostData"));
  const access_token = sessionStorage.getItem("access_token");
  const [hotSpotArray, setHotSpotArray] = useState([]);
  const [highestIndexArray, setHighestIndexArray] = useRecoilState(HighestIndexArray);

  //For scenario saving Data -->
  const co2PerPartPM = useRecoilValue(CCPolyCo2ePerPartPMData);
  const co2PerPartMP = useRecoilValue(CCPolyCo2ePerPartMPData);
  const co2PerPartAP = useRecoilValue(CCPolyCo2ePerPartAPData);
  const materialTransportaion = useRecoilValue(
    CCPolyMaterialTransportationData
  );

  const systemTransportation = useRecoilValue(CCPolySystemTransportationData);

  const cefnone = useRecoilValue(CCPolyCarbonEmissionFactorNode1Data);

  const cefnTwo = useRecoilValue(CCPolyCarbonEmissionFactorNode2Data);
  const cNPInput = useRecoilValue(CCPolyCarbonNeutralPowder)
  const volumeReductionInput = useRecoilValue(CCPolyVolumeReductionState)
  const energyPercentageInput = useRecoilValue(CCPolyEnergyPercentage)
  const greenPowderEnergyInput = useRecoilValue(CCPolyGreenPowderEnergy)
  const modeOfTranspotation1 = useRecoilValue(CCPolyModeOfTranspotation1)
  const modeOfTranspotation2 = useRecoilValue(CCPolyModeOfTranspotation2)
  //For scenaario saving data <--

  const [show, setShow] = useState(false);
  const [scenarioName, setScenarioName] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const machineName = useGetMachineName(+costData?.machine_id?.value);
  const materialName = useGetMaterialName(+costData?.material_id?.value);
  const refreshRate = useRecoilValue(CCRefreshRateScenarioState);

  const DataSet = [
    {
      name: "CO2e Powder:",
      color: "#5197F7",
      title: co2ePowder
        ? ((co2ePowder / co2TotalToday) * 100).toFixed(2) + "%"
        : "",
      value: parseFloat(((co2ePowder / co2TotalToday) * 100).toFixed(2)),
    },
    {
      name: "CO2e Energy:",
      color: "#B7D5FB",
      title: co2eEnergy
        ? ((co2eEnergy / co2TotalToday) * 100).toFixed(2) + "%"
        : "",
      value: parseFloat(((co2eEnergy / co2TotalToday) * 100).toFixed(2)),
    },
    {
      name: "CO2e Logistics Generate Report:",
      color: "#A1A19D",
      title: co2TotalTransportation
        ? ((co2TotalTransportation / co2TotalToday) * 100).toFixed(2) + "%"
        : "",
      value: parseFloat(
        ((co2TotalTransportation / co2TotalToday) * 100).toFixed(2)
      ),
    },
  ];

  let arr = []
  useEffect(() => {
    if (
      cPowder !== undefined &&
      Powder !== undefined &&
      Energy !== undefined &&
      energyMaterial !== undefined &&
      co2TotalTransportation !== undefined &&
      EnergySystem !== undefined &&
      co2TotalToday !== undefined
    ) {
      setPowder(parseFloat(cPowder.today));
      setVolumeReduction(parseFloat(volumeReduction?.today));
      setCo2ePowder(parseFloat(Powder?.today));
      setCo2eEnergy(parseFloat(Energy?.today));
      setEnergyMaterial(parseFloat(energyMaterial?.today));
      setEnergySystem(parseFloat(EnergySystem?.today));
      arr.push({
        "CO2e Powder": Powder.today,
        "CO2e Energy": Energy.today,
        "CO2e Logistics": co2TotalTransportation,
      });
      setHotSpotArray(arr);
      setHighestIndexArray(arr);
      // Store co2TotalToday in localStorage
      if (co2TotalToday) {
        sessionStorage.setItem("co2TotalToday", co2TotalToday.toString());
      }
      const parent = document.getElementById("m2");
    const firstchild = parent.firstChild;
    firstchild.setAttribute("viewBox", "-25 -12 150 125");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cPowder,
    Powder,
    Energy,
    energyMaterial,
    co2TotalTransportation,
    EnergySystem,
    co2TotalToday,
  ]);

  const SaveScenario = async () => {
    toast.info("Please Wait...");
    const formFields = {
      technology_id: techId,
      step_type_id: stepId,
      technology_name: techName,
      machine_name: machineName,
      material_name: materialName,
      material_id: +costData?.material_id?.value,
      machine_id: +costData?.machine_id?.value,
      costData: costData,
      co2PerPartPM: co2PerPartPM,
      co2PerPartMP: co2PerPartMP,
      co2PerPartAP: co2PerPartAP,
      co2TotalTransportation: co2TotalTransportation,
      materialTransportaion: materialTransportaion,
      systemTransportation: systemTransportation,
      cefnone: cefnone,
      cefnTwo: cefnTwo,
      cNPInput: cNPInput,
      volumeReductionInput: volumeReductionInput,
      energyPercentageInput: energyPercentageInput,
      greenPowderEnergyInput: greenPowderEnergyInput,
      modeOfTranspotation1: modeOfTranspotation1,
      modeOfTranspotation2: modeOfTranspotation2,
      refreshRate: +refreshRate
    };
    const data = {
      scenario_data: JSON.stringify(formFields),
      scenario_name: scenarioName,
    };
    try {
      const response = await axios.post(
        `${config.serviceUrl}client/scenario/save`,
        data,
        {
          headers: {
            Authorization: access_token,
          },
        }
      );

      if (response.data) {
        toast.success("Scenario saved Successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="d-flex flex-column accordion">
      <ToastContainer />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Enter scenario name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-section">
            <DebounceInput
              type="text"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => {
                setScenarioName(e.target.value);
              }}
              onWheel={(e) => e.target.blur()}
              placeholder="Please enter scenario name"
              value={scenarioName}
            />
            {/* <p className="edit-icon value-unit">kg</p> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center w-100">
            <button
              className="button1 button btn-primary"
              onClick={handleClose}
            >
              Close
            </button>
            <Button
              disabled={scenarioName.length === 0}
              className="button1 button btn-black"
              onClick={() => {
                SaveScenario();
                handleClose();
              }}
            >
              Save Scenario
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="powder-container">
        <div className="d-flex flex-row justify-content-between mb-24">
          <p className="font-24 font-semi-bold">Scenario Analysis</p>
          <button onClick={handleShow} className="scenario-button ">
            <div className="d-flex flex-row gap-8 ">
              <img src="../assets/save1.png" alt="" />
              <span>Save Scenario</span>
            </div>
          </button>
        </div>
        <div className="d-flex flex-row p-3">
          {/* <MaterialTable Socket={socket} /> */}
          {/* <MaterialTableValues Socket={socket} /> */}
          <MaterialTableValues1 Socket={socket} />
        </div>
        <div className="powder-table-top">
          <p className="powder-heading p-0" style={{ width: "528px" }}>
            Total (kg)
          </p>
          <div className="d-flex ">
            <p className="powder-heading  p-0 " style={{ width: "272px" }}>
              {co2TotalToday}
            </p>
            <p className="powder-heading  p-0">{co2TotalTomorrow}</p>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <div className="graph-section width--mod">
          <p className="font-16 font-semi-bold mb-16">
            CO2e in % of kg per part
          </p>
          <p className="font-14">Current Scenario</p>
          <div
            className="d-flex flex-row "
            style={{ padding: " 24px 34px 16px 34px" }}
          >
            <div
              id="m2"
              className=" d-flex justify-content-center align-items-center"
            >
              <PieChart
                animationDuration={500}
                animationEasing="ease-out"
                // center={[50, 50]}
                width=" 300px"
                height="300px"
                data={DataSet}
                labelPosition={110}
                lengthAngle={360}
                lineWidth={40}
                paddingAngle={2}
                radius={PieChart.defaultProps.radius - shiftSize}
                startAngle={0}
                // label={({ dataEntry }) => dataEntry.title}
                // segmentsShift={(index) => (index === 3 ? shiftSize : 0.2)}
                // labelStyle={{
                //   fill: "black",
                //   strokeWidth: "10",
                //   fontSize: "5px",
                //   fontFamily: "Open Sans, sans-serif",
                //   fontWeight: "600",
                // }}
              />
            </div>
            <div className="d-flex justify-content-center flex-column gap-8 ">
              {DataSet?.map((item) => (
                <div className="flex flex-row" style={{ gap: "5px" }}>
                  <span className="font-14">{item.name}</span>
                  <span className="font-weight-bold font-14">{item.title}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-8">
        <div className="d-flex">
          <div className="color-icon bg-color5" />
          <p className="color-rep-value">CO2e Powder</p>
        </div>
        <div className="d-flex">
          <div className="color-icon bg-color7 " />
          <p className="color-rep-value ">CO2e Energy</p>
        </div>
        <div className="d-flex">
          <div className="color-icon bg-color1 " />
          <p className="color-rep-value m-0">CO2e Logistics</p>
        </div>
      </div>
        </div>
      </div>



      {/* <div className="d-flex justify-content-center align-items-center">
        <button
        // onClick={() => ScenarioState()}
          onClick={() => {
            window.location.href = "/calculator/visual-analytics/true";
          }}
          className="selection-button step-button"
        >
          Visual Analytics
        </button>
        <button onClick={handleShow} className="selection-button step-button">
          Save My Scenario
        </button>
      </div> */}
    </div>
  );
};

export default Scenario;
